import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Seite nicht gefunden – PINE Systems"
        description="Diese Seite existiert nicht. Zurück zur PINE Systems Startseite oder direkt Standortpotenzial prüfen."
        noindex
      />
      <section className="relative min-h-[70vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 grid-overlay opacity-30" />
        <div className="relative max-w-3xl mx-auto px-6 md:px-12 py-24 text-center w-full">
          <div className="overline mb-6 mx-auto">Fehler 404</div>
          <h1 className="font-display text-6xl md:text-8xl uppercase leading-[1] text-[#18E096]">
            404
          </h1>
          <h2 className="font-display text-2xl md:text-3xl uppercase mt-6 leading-tight">
            Diese Seite existiert nicht.
          </h2>
          <p className="text-[#AEB7B7] mt-6 max-w-xl mx-auto leading-relaxed">
            Vielleicht wurde die Adresse falsch eingegeben oder die Seite wurde verschoben.
            Hier geht es zurück zu den relevanten Bereichen.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            <Link to="/" className="btn-primary" data-testid="nf-home">
              Zur Startseite <ArrowUpRight size={16} strokeWidth={1.5} />
            </Link>
            <Link to="/systeme" className="btn-secondary" data-testid="nf-systeme">
              Systeme
            </Link>
            <Link to="/standort-pruefen" className="btn-secondary" data-testid="nf-pruefen">
              Standort prüfen
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
